import dayjs from 'dayjs';
import { TIME_DATE } from 'utils/helpers/constVariables';

export const shiftTitle = (marks: { time: string }[] | undefined | null) => {
  const timeString = (time: string) => dayjs(time).format(TIME_DATE);
  if (!marks?.length) return '—:—';
  if (marks[1]) return `${timeString(marks[0].time)} – ${timeString(marks[marks.length - 1].time)}`;
  return `${timeString(marks[0].time)} – —:—`;
};
